export const OfferHasExpired = {
    en: "We‘re sorry，the offer has expired.",
    cs: "Litujeme, nabídka vypršela.",
    da: "Vi beklager, men tilbuddet er udløbet.",
    de: "Es tut uns leid, das Angebot ist nicht mehr gültig.",
    el: "Λυπούμαστε, η προσφορά έχει λήξει.",
    es: "Lo sentimos, la oferta se ha terminado.",
    hr: "Žao nam je， ponuda je istekla.",
    fr: "Nous sommes désolés, l'offre a expiré.",
    hu: "Sajnáljuk, az ajánlat lejárt.",
    id: "Maaf, penawaran ini telah kedaluwarsa.",
    it: "Siamo spiacenti, l'offerta è scaduta.",
    ja: "大変申し訳ありません。有効期限が過ぎてしまいました。",
    ko: "죄송합니다. 쿠폰이 만료되었습니다.",
    nl: "Sorry, het aanbod is verlopen.",
    no: "Vi beklager, tilbudet har utløpt.",
    pl: "Przepraszamy, oferta wygasła.",
    pt: "Lamentamos, a oferta expirou.",
    ro: "Ne pare rău, oferta a expirat.",
    ru: "К сожалению, срок действия предложения истек.",
    sv: "Tyvärr, erbjudandet har gått ut.",
    th: "ขออภัย ข้อเสนอหมดอายุแล้ว",
    tr: "Üzgünüz, teklifin süresi doldu.",
    ar: "نأسف، انتهى العرض",
};
export const EndsIn = {
    en: "Starts On",
    cs: "Začíná dne",
    da: "Starter på",
    de: "Beginnt am",
    el: "Ξεκινά στις",
    es: "Comienza en",
    hr: "Započinje",
    fr: "Commence le",
    hu: "Kezdődik",
    id: "Mulai",
    it: "Comincia il",
    ja: "開始日",
    ko: "시작",
    nl: "Begint op",
    no: "Starter den",
    pl: "Rozpoczęcie",
    pt: "Começa Em",
    ro: "Începe în",
    ru: "Начало:",
    sv: "Börjar den",
    th: "เริ่มใน",
    tr: "Başlama Zamanı",
    ar: "العرض يبدأ في",
};
export const StartsOn = {
    en: "Starts On",
    cs: "Začíná dne",
    da: "Starter på",
    de: "Beginnt am",
    el: "Ξεκινά στις",
    es: "Comienza en",
    hr: "Započinje",
    fr: "Commence le",
    hu: "Kezdődik",
    id: "Mulai",
    it: "Comincia il",
    ja: "開始日",
    ko: "시작",
    nl: "Begint op",
    no: "Starter",
    pl: "Rozpoczęcie",
    pt: "Começa Em",
    ro: "Începe în",
    ru: "Начало:",
    sv: "Börjar den",
    th: "เริ่มใน",
    tr: "Başlama Zamanı",
    ar: "العرض يبدأ في",
};
export const MonthsLan = {
    en: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],
    nl: [
        "januari-",
        "februari",
        "maart",
        "april",
        "mei",
        "juni-",
        "juli-",
        "augustus",
        "september",
        "oktober",
        "november",
        "december",
    ],
    da: [
        "januar",
        "februar",
        "marts",
        "April",
        "Kan",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december",
    ],
    sv: [
        "januari",
        "februari",
        "Mars",
        "april",
        "Maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december",
    ],
    fi: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "saattaa",
        "kesäkuu",
        "heinäkuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu",
    ],
    it: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "Maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre",
    ],
    "pt": [
        "Janeiro",
        "fevereiro",
        "Março",
        "abril",
        "Maio",
        "Junho",
        "julho",
        "agosto",
        "setembro",
        "Outubro",
        "novembro",
        "dezembro",
    ],
    hu: [
        "január",
        "február",
        "március",
        "április",
        "Lehet",
        "június",
        "július",
        "augusztus",
        "szeptember",
        "október",
        "november",
        "december",
    ],
    "no": [
        "januar",
        "februar",
        "mars",
        "april",
        "Kan",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember",
    ],
    cs: [
        "leden",
        "Únor",
        "březen",
        "duben",
        "Smět",
        "červen",
        "červenec",
        "srpen",
        "září",
        "říjen",
        "listopad",
        "prosinec",
    ],
    pl: [
        "styczeń",
        "luty",
        "Marsz",
        "kwiecień",
        "Może",
        "czerwiec",
        "lipiec",
        "sierpień",
        "wrzesień",
        "październik",
        "listopad",
        "grudzień"
    ],
    fr: [
        "janvier",
        "février",
        "Mars",
        "avril",
        "Mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
    ],
    es: [
        "enero",
        "febrero",
        "marcha",
        "abril",
        "Mayo",
        "junio",
        "mes de julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
    ],
    de: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Kann",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
    ],
    he: [
        "יָנוּאָר",
        "פברואר",
        "מרץ",
        "אַפּרִיל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "סֶפּטֶמבֶּר",
        "אוֹקְטוֹבֶּר",
        "נוֹבֶמבֶּר",
        "דֵצֶמבֶּר",
    ],
    ja: [
        "1月",
        "2月",
        "行進",
        "四月",
        "五月",
        "六月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
    ],
    ru: [
        "январь",
        "февраль",
        "маршировать",
        "апреля",
        "Может",
        "июнь",
        "июль",
        "август",
        "сентябрь",
        "октября",
        "ноябрь",
        "Декабрь",
    ],
    ar: [
        "كانون الثاني",
        "شهر فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "تموز",
        "أغسطس",
        "شهر سبتمبر",
        "اكتوبر",
        "شهر نوفمبر",
        "ديسمبر",
    ],
    ko: [
        "일월",
        "이월",
        "행진",
        "4 월",
        "할 수있다",
        "유월",
        "칠월",
        "팔월",
        "구월",
        "십월",
        "십일월",
        "12 월",
    ],
    tr: [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
    ],
    el: [
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Ενδέχεται",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος",
    ],
    hr: [
        "siječanj",
        "veljača",
        "ožujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac",
    ],
    ro: [
        "ianuarie",
        "februarie",
        "Martie",
        "Aprilie",
        "Mai",
        "iunie",
        "iulie",
        "August",
        "Septembrie",
        "octombrie",
        "noiembrie",
        "decembrie",
    ],
    th: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "อาจ",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
    ],
    id: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mungkin",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ]
};
